import styled from "styled-components";
import Button from '@mui/material/Button';

export const StyledButton = styled(Button)`
    border-radius: 50px !important;
    width: 80px;
    height: 32px;
    color: white !important;
    background-color: ${({backgroundcolor})=>backgroundcolor} !important;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Typography = styled.div`
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
    font-size: 10px;
    font-weight: 600 !important;
    align-self: flex-end;
`